import React, { useEffect, useState, useContext } from 'react'
import ListingTableView from '@/custom/components/organisms/Product/TableView'
import { Button } from '@mui/material'
import Layout from '@/product/components/templates/Layout'
import DynamicListing from './dynamicListing'
import ReportContext from '@/product/context/report/reportContext'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import DynamicBulkListing from '@/product/components/organisms/BulkUpload/ProjectUpload'
import MakeOffer from './MakeOffer'
import Comments from '../Comments/Comments'
import ReturnLogs from '@/views/ReturnLogs'
import { handleRedirectInternal } from '@/custom/common/components'
import { useHistory } from 'react-router-dom'
import commonContext from '@/product/context/common/commonContext'
import AuthContext from '@/product/context/auth/authContext'
import BulkListing from '@/views/Listing/BulkListing'
import CustomCommonContext from '@/custom/context/common/commonContext'
import AlertContext from '@/product/context/alert/alertContext'

const ListingCommon = (props) => {
    const dynamicContext = useContext(DynamicContext)
    const dashboardContext = useContext(commonContext)

    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext

    const { getMainDashboardData } = dashboardContext
    const { alldata_all_dropdown, allCategory } =
        useContext(CustomCommonContext)
    const { project_tablefields } = dynamicContext
    const authContext = useContext(AuthContext)
    const { user, isAuthenticated } = authContext

    const { getAllExportDownload } = useContext(ReportContext)

    const [searchInfo, setSearchInfo] = useState({})
    const [tableValue, setTableValue] = useState([])
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
        projectType: 0,
    })
    const [bulkPopup, setBulkPopup] = useState(false)
    const toggleBulkPopup = (popup) => {
        if (user?.emp_type === 'seller') {
            if (user?.users_seller_account_status === 'completed') {
                setBulkPopup({ popup })
            } else {
                setAlert('Need to complete the onboarding', 'error')
            }
        } else {
            setBulkPopup({ popup })
        }
    }
    const history = useHistory()
    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'edit') {
            handleRedirectInternal(history, `listing/edit/${id}`)
        }
    }
    const onClickInvoiceEdit = (id, secondaryID, type) => {
        handleRedirectInternal(history, `invoice/view/all/${id}/${secondaryID}`)
    }

    const toggleFullScreenPopup = (popup, status, id, projectType) => {
        if (user?.emp_type === 'seller') {
            if (user?.users_seller_account_status === 'completed') {
                if (popup && (status == 'new' || status == 'edit')) {
                    handleRedirectInternal(history, `listing/${status}/${id}`)
                } else if (popup) {
                    setManage({ popup, status, id, projectType })
                } else {
                    setManage({ popup, status: 'new', id: 0 })
                }
            } else {
                setAlert('Need to complete the onboarding', 'error')
            }
        } else {
            if (popup && (status == 'new' || status == 'edit')) {
                handleRedirectInternal(history, `listing/${status}/${id}`)
            } else if (popup) {
                setManage({ popup, status, id, projectType })
            } else {
                setManage({ popup, status: 'new', id: 0 })
            }
        }
    }

    let action = props.match.params.action
    console.log('val=======>', action)
    const custom = {
        action: {
            value: action
                ? action.toString() !== 'all'
                    ? action.toString()
                    : ''
                : null,
            type: 'in',
            field: 'p.market_status',
        },
        delete_status: {
            value: action.toString() === 'draft' ? 'delete' : '',
            type: 'notin',
            field: 'p.status',
        },
    }

    const filterElements = [
        'dimension_length',
        'dimension_width',
        'dimension_height',
        'dimension_unit',
        'weight_value',
        'weight_unit',
        'origin_zip',
        'location_id',
        'local_pickup_dates',
        'local_pickup_start_hour',
        'local_pickup_end_hour',
        'local_pickup_appt_per_slot',
        'local_pickup_slot_timeframe',
        'station_package_code',
        'station_warehouse',
    ]

    useEffect(() => {
        if (project_tablefields && project_tablefields.length) {
            let dynamicValueAssign = {}
            let searchData = project_tablefields
            dynamicValueAssign.data = searchData
                .filter((item) => item.table_search === 1)
                .map((buscat) => {
                    return Object.assign(buscat, {
                        name: buscat.field,
                    })
                })
            setSearchInfo(dynamicValueAssign)
            let dynamicAssign = [...project_tablefields]
            dynamicAssign.map((data) => {
                if (data.field === 'auctiontitle') {
                    data.click = true
                    data.onclick = onClickEdit
                    data.clickID = 'id'
                    data.secondaryClickID = 'user_id'
                    data.clickType = 'edit'
                    data.type = 'hyperlink'
                } else if (data.field == 'buynow_project_id') {
                    data.filterField = 'p.id'
                    data.filterable = 1
                    data.label = 'Product ID'
                } else if (data.field == 'date_closed') {
                    data.type = 'date'
                } else if (data.field == 'id') {
                    data.filterField = 'p.id'
                    data.filterable = 1
                    data.label = 'Product ID'
                } else if (data.field == 'buynow_common_invoice') {
                    data.click = true
                    data.onclick = onClickInvoiceEdit
                    data.clickID = 'buynow_common_invoice'
                    data.secondaryClickID = 'buynow_user_id'
                    data.clickType = 'edit'
                    data.type = 'hyperlink'
                } else if (data.field == 'category') {
                    data.valueOptions = allCategory
                        .filter((value) => value.level === 0)
                        .map((item) => {
                            let valueChanged = {}
                            valueChanged.label = item.description
                            valueChanged.value = item.id
                            return valueChanged
                        })
                    data.type = 'singleSelect'
                } else if (data.field == 'conditionTypeId') {
                    data.valueOptions = alldata_all_dropdown
                        .filter(
                            (value) =>
                                value.variable === 'conditionTypeId' &&
                                value.level === 0
                        )
                        .map((item) => {
                            let valueChanged = {}
                            valueChanged.label = item.description
                            valueChanged.value = item.id.toString()
                            return valueChanged
                        })
                    data.category = true
                    data.type = 'singleSelect'
                } else if (data.field === 'location') {
                    data.location = true
                } else if (data.field === 'title') {
                    data.click = true
                    data.onclick = onClickEdit
                    data.clickID = 'id'
                    data.secondaryClickID = 'id'
                    data.clickType = 'edit'
                    data.type = 'hyperlink'
                }
            })

            if (action === 'draft') {
                dynamicAssign.push({
                    active: 1,
                    field: 'requiredFieldsStatus',
                    folder: null,
                    id: 21,
                    is_deletable: 0,
                    label: 'Status',
                    show_order: 500,
                    sort: 0,
                    sort_field: 'p.wprice',
                    table_search: 0,
                    type: 'tooltip',
                    tooltipTitle: 'requiredFields',
                    tooltipType: 'field',
                    view_page: '1',
                })
            }
            if (action === 'sold' || action === 'relisted') {
                dynamicAssign.push(
                    {
                        id: 2020,
                        click: true,
                        active: 1,
                        table_search: 1,
                        field: 'buynow_common_invoice',
                        type: 'hyperlink',
                        clickID: 'buynow_common_invoice',
                        secondaryClickID: 'buynow_user_id',
                        onclick: onClickInvoiceEdit,
                        clickType: 'edit',
                        firstChild: true,
                        sort: false,
                        disablePadding: false,
                        label: 'Invoice #',
                        filterable: true,
                        filterField: 'b.common_invoice',
                    },
                    {
                        active: 1,
                        table_search: 0,
                        field: 'buynow_amount',
                        type: 'price',
                        firstChild: false,
                        sort: true,
                        disablePadding: false,
                        label: 'Subtotal',
                        filterable: true,
                        filterField: 'b.amount',
                    }
                )
            }
            if (action === 'sold') {
                dynamicAssign.push(
                    {
                        field: 'buynow_paid',
                        condition: true,
                        conditionValue: {
                            formula: {
                                key1: 'buynow_paid',
                                key2: 1,
                                notation: '==',
                            },
                            true: {
                                type: 'text',
                                value: 'Paid',
                            },
                            false: {
                                type: 'text',
                                value: 'Unpaid',
                            },
                        },
                        type: 'singleSelect',
                        sort: true,
                        firstChild: false,
                        disablePadding: false,
                        label: 'Paid Status',
                        filterable: true,
                        filterField: 'b.paid',
                        valueOptions: [
                            { value: '0', label: 'Unpaid' },
                            { value: '1', label: 'Paid' },
                        ],
                        valueGetter: (params) => {
                            return params.value !== null &&
                                params.value !== undefined
                                ? params.value.toString()
                                : 'Unknown'
                        },
                    },
                    {
                        field: 'buynow_return_request_status',
                        type: 'singleSelect',
                        sort: true,
                        firstChild: false,
                        disablePadding: false,
                        label: 'Pickup Status',
                        filterable: true,
                        filterField: 'b.return_request_status',
                        valueOptions: [
                            { value: '0', label: 'Not Picked Up' },
                            { value: '1', label: 'Picked Up' },
                            { value: '2', label: 'Pending Return' },
                            { value: '3', label: 'Returned' },
                            { value: '4', label: 'Need Relisted' },
                        ],
                        valueGetter: (params) => {
                            return params.value !== null &&
                                params.value !== undefined
                                ? params.value.toString()
                                : 'Unknown'
                        },
                    },
                    {
                        active: 1,
                        table_search: 0,
                        field: 'buynow_total_premium',
                        type: 'price',
                        firstChild: false,
                        sort: true,
                        disablePadding: false,
                        label: 'ZB Fee',
                        filterable: true,
                        filterField: 'b.total_premium',
                    },
                    {
                        active: 1,
                        table_search: 0,
                        field: 'buynow_total_tax',
                        type: 'price',
                        firstChild: false,
                        sort: true,
                        disablePadding: false,
                        label: 'Tax Amount',
                        filterable: true,
                        filterField: 'b.total_tax',
                    },
                    {
                        active: 1,
                        table_search: 0,
                        field: 'buynow_total_amount',
                        type: 'price',
                        firstChild: false,
                        sort: true,
                        disablePadding: false,
                        label: 'Total Amount',
                        filterable: true,
                        filterField: 'b.total_amount',
                    },
                    {
                        active: 1,
                        table_search: 0,
                        field: 'buynow_total_invoice',
                        type: 'price',
                        firstChild: false,
                        sort: true,
                        disablePadding: false,
                        label: 'Total Invoice Amount',
                        filterable: true,
                        filterField: 'b.total_invoice',
                    }
                )
            }
            console.log('val=======>', dynamicAssign)
            setTableValue(dynamicAssign)
        }
        getMainDashboardData(global.customDashboardFilter)
    }, [project_tablefields, action])
    const exportFields = [
        {
            field: 'item_id',
            type: '',
            name: 'Item ID',
        },
    ]

    return (
        <>
            <Layout>
                <div className="dashboard listing maillisting ddd">
                    <div className="miscActions d-flex justify-content-start align-items-center flex-wrap mt-4">
                        <Button
                            id="listingDynamic_add"
                            variant="outlined"
                            className="btnOutlined mr-2"
                            onClick={() =>
                                toggleFullScreenPopup(true, 'new', 0, 5)
                            }
                        >
                            <span className="material-icons">note_add</span>Add
                            New Listing
                        </Button>
                        <Button
                            id="listingDynamic_bulk"
                            variant="outlined"
                            className="btnOutlined"
                            onClick={() => toggleBulkPopup(true)}
                        >
                            <span className="material-icons">note_add</span>Add
                            New Bulk Listing
                        </Button>
                        {user?.emp_type === 'super_admin' ||
                        user?.emp_type === 'admin' ? (
                            <Button
                                id="listingDynamic_report"
                                variant="outlined"
                                className="btnOutlined"
                                onClick={() =>
                                    getAllExportDownload({
                                        action: 'export',
                                        order: 'asc',
                                        orderby: '',
                                        spreadDefaultsFirst: true,
                                        fields: exportFields,
                                        replaceObjects: exportFields,
                                        search: 'all',
                                        report: `${action}_product_management`,
                                    })
                                }
                            >
                                <span className="material-icons-outlined">
                                    file_download
                                </span>
                                Export All Data
                            </Button>
                        ) : null}
                    </div>
                    <div className="asdad">
                        <ListingTableView
                            searchInfo={searchInfo}
                            customFilter={custom}
                            tableValue={tableValue}
                            noLotId={true}
                            // printlabel={false}
                            noEvent={true}
                            drafttoActiveStatus={true}
                            printFieldTitle={'Lpn Number'}
                            printLabelField={'scan_lpn_number'}
                            includetext={true}
                            defaultPrintSize={'zebra-large'}
                            toggleFullScreenPopup={toggleFullScreenPopup}
                            tableActionString={[
                                'relist',
                                'open',
                                'unsold',
                                'date_closed',
                                'removed',
                            ]}
                            listActionString={
                                global?.listActionString
                                    ? global.listActionString
                                    : []
                            }
                            action={action}
                            diff_id={'uuid'}
                            columnStorageVariable={'table_listing_dynamic'}
                            showProxyBid={true}
                            delete_bid={
                                user?.emp_type === 'super_admin' ? true : false
                            }
                        />
                    </div>
                </div>
                {/* <DynamicListing
                    data={manage}
                    function={toggleFullScreenPopup}
                /> */}
                <MakeOffer data={manage} function={toggleFullScreenPopup} />
                <Comments data={manage} function={toggleFullScreenPopup} />
                <ReturnLogs data={manage} function={toggleFullScreenPopup} />
                {/* <DynamicBulkListing
                    data={bulkPopup}
                    function={toggleBulkPopup}
                    ignoreFields={
                        global?.bulk_ignoreFields
                            ? global.bulk_ignoreFields
                            : []
                    }
                /> */}
                <BulkListing
                    data={bulkPopup}
                    filterElements={filterElements}
                    function={toggleBulkPopup}
                    ignoreFields={
                        global?.bulk_ignoreFields
                            ? global.bulk_ignoreFields
                            : []
                    }
                    // customLocationFilter={{ key: 'user_id', value: user?.id }}
                    customDescription={'name'}
                    imageUpload={true}
                />
            </Layout>
        </>
    )
}

export default ListingCommon
